(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5236],{

/***/ 858:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sobre",
      function () {
        return __webpack_require__(4530);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ About; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_Institutional_InstitutionalPage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3373);
/* harmony import */ var _components_Internals_InternalSchema__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2491);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7590);




var __N_SSP = true;
function About(param) {
    var institutionalData = param.institutionalData, navBarData = param.navBarData, ssr = param.ssr, schema = param.schema;
    var data = institutionalData.data;
    var cabecalho = data.cabecalho, conteudo = data.conteudo, equipe = data.equipe;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        layoutData: {
            segmentacoes: [],
            tagsData: ssr,
            navBarData: navBarData
        },
        children: [
            schema && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Internals_InternalSchema__WEBPACK_IMPORTED_MODULE_2__/* .ApplySchema */ .BR, {
                schema: schema
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Institutional_InstitutionalPage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                text: conteudo,
                title: "Quem Somos",
                headerImg: {
                    url: cabecalho.imagem.url,
                    blurhash: cabecalho.imagem.blurhash,
                    srcset: cabecalho.imagem.srcset
                },
                breadcrumbs: [],
                members: equipe,
                type: "sobre"
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [162,1216,8912,8802,7590,944,6869,3373,9774,2888,179], function() { return __webpack_exec__(858); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);